var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user_list_page", attrs: { a: _vm.getWidth } },
    [
      _c("pageTitle"),
      _c("businessGroup", {
        ref: "businessGroup",
        attrs: {
          tableConfig: { ..._vm.tableConfig },
          formConfig: { ..._vm.formConfig },
          rowClassName: _vm.setRowClassName,
        },
        scopedSlots: _vm._u([
          {
            key: "conflictReason",
            fn: function (conflictReason) {
              return [
                conflictReason.conflictReason
                  ? _c(
                      "a-tooltip",
                      [
                        _c("template", { slot: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(conflictReason.conflictReason || "暂无") +
                              " "
                          ),
                        ]),
                        _c("a-icon", {
                          attrs: { type: "question-circle", theme: "twoTone" },
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "formSlot",
            fn: function (formSlot) {
              return [
                _c(
                  "a-form-item",
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["keyword"],
                          expression: "['keyword']",
                        },
                      ],
                      staticStyle: {
                        width: "200px",
                        "margin-right": "10px",
                        "vertical-align": "middle",
                      },
                      attrs: { placeholder: "请输入效果名称/上传者" },
                    }),
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["checkStatus"],
                            expression: "['checkStatus']",
                          },
                        ],
                        staticStyle: { width: "150px" },
                        attrs: { placeholder: "请选择状态" },
                      },
                      _vm._l(_vm.checkStatusSelect, function (el) {
                        return _c(
                          "a-select-option",
                          { key: el.value, attrs: { value: el.value } },
                          [_vm._v(_vm._s(el.label) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "lightType",
            fn: function (record) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm.createMaps(_vm.lightType, record.lightType)) +
                    " "
                ),
              ]
            },
          },
          {
            key: "effectType",
            fn: function (record) {
              return [
                record.effectType === "PICTURE"
                  ? _c("m-image", { attrs: { url: record.effectUrl } })
                  : _vm._e(),
                record.effectType === "VIDEO"
                  ? _c("mVideo", {
                      attrs: {
                        "img-url": record.videoCover,
                        "video-url": record.effectUrl,
                      },
                    })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "action",
            fn: function (record) {
              return [
                record.checkStatus === "WAIT_CHECK"
                  ? _c(
                      "span",
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "link" },
                            on: { click: () => _vm.action(record, 1) },
                          },
                          [_vm._v("审核通过")]
                        ),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "link" },
                            on: { click: () => _vm.action(record, 0) },
                          },
                          [_vm._v("拒绝")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                record.checkStatus === "REJECT"
                  ? _c(
                      "a-button",
                      {
                        attrs: { type: "link" },
                        on: { click: () => _vm.show(record.rejectReason) },
                      },
                      [_vm._v("拒绝原因")]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "avatar",
            fn: function (record) {
              return [
                _c(
                  "viewer",
                  { attrs: { images: [record.avatar] } },
                  [
                    _c("a-avatar", {
                      attrs: { src: record.avatar, size: "large" },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "checkStatus",
            fn: function (record) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.checkStatusMaps[record.checkStatus]) + " "
                ),
              ]
            },
          },
          {
            key: "lightEffect",
            fn: function (record) {
              return [
                record.lightType === "WHITE_LIGHT"
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "亮度: " + _vm._s(record.brightness || 0) + " %"
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "色温: " + _vm._s(record.colorTemperature || 0) + " K"
                        ),
                      ]),
                      record.lightEffect === "COLOR_TEMPERATURE_PIECE"
                        ? _c("div", [
                            _c("p", [
                              _vm._v(
                                "CTO: " + _vm._s(record.cto || 0) + " CTO"
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "CTB: " + _vm._s(record.ctb || 0) + " CTB"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                record.lightType === "COLORAMA"
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "亮度: " + _vm._s(record.brightness || 0) + " %"
                        ),
                      ]),
                      _c("p", [
                        _vm._v("CTB: " + _vm._s(record.ctb || 0) + " CTB"),
                      ]),
                      record.lightEffect === "COLOR_COORDINATE"
                        ? _c("div", [
                            _c("p", [
                              _vm._v(
                                "色坐标: " +
                                  _vm._s(record.xtAxis) +
                                  " " +
                                  _vm._s(record.ytAxis)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                record.lightType === "LIGHT_EFFECT"
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "亮度: " + _vm._s(record.brightness || 0) + " %"
                        ),
                      ]),
                      _c("p", [
                        _vm._v("色相: " + _vm._s(record.hue || 0) + " °"),
                      ]),
                      _c("p", [
                        _vm._v(
                          "饱和: " + _vm._s(record.saturation || 0) + " %"
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "CTB: " + _vm._s(record.intensity || 0) + " CTB"
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c(
        "a-modal",
        {
          staticClass: "m-modal",
          staticStyle: { "margin-bottom": "10px" },
          attrs: {
            visible: _vm.visibleChange,
            width: 400,
            title: "审核",
            maskClosable: false,
          },
          on: { cancel: _vm.handleCancel, ok: _vm.handleOk },
        },
        [
          !_vm.actionStatus
            ? _c(
                "div",
                [
                  _c("a-textarea", {
                    attrs: {
                      "auto-size": { minRows: 3, maxRows: 5 },
                      placeholder: "请填写不通过的理由",
                    },
                    model: {
                      value: _vm.rejectReason,
                      callback: function ($$v) {
                        _vm.rejectReason = $$v
                      },
                      expression: "rejectReason",
                    },
                  }),
                ],
                1
              )
            : _c(
                "span",
                { staticStyle: { display: "block", "text-align": "center" } },
                [_vm._v("是否通过该效果的分享")]
              ),
        ]
      ),
      _c(
        "a-modal",
        {
          staticClass: "m-modal",
          staticStyle: { "margin-bottom": "10px" },
          attrs: {
            visible: _vm.rejectReasonShow,
            width: 400,
            title: "拒绝原因",
            maskClosable: false,
          },
          on: { cancel: _vm.close },
        },
        [
          _c(
            "span",
            { staticStyle: { display: "block", "text-align": "left" } },
            [_vm._v(_vm._s(_vm.rejectReason))]
          ),
          _c(
            "template",
            { slot: "footer" },
            [_c("a-button", { on: { click: _vm.close } }, [_vm._v("关闭")])],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }